import { ToastProgrammatic as Toast } from 'buefy';

export default function gestionErreur(message) {
  Toast.open({
    duration: 5000,
    message: message,
    position: 'is-top',
    type: 'is-danger',
  });
}



// WEBPACK FOOTER //
// ./src/services/general/gestionErreur.js